import React from 'react';
import { Box } from '@mui/material';
import SideNav from './SideNav';
import MainNav from './MainNav';
import { SidebarProvider, useSidebar } from './SidebarContext';

const DashboardLayoutContent = ({ children }) => {
  const { sidebarWidth } = useSidebar();

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
      <SideNav />
      <Box
        sx={{
          display: 'flex',
          flex: '1 1 auto',
          flexDirection: 'column',
          pl: { lg: `${sidebarWidth}px` },
          width: '100%',
          minWidth: 0,
          transition: (theme) =>
            theme.transitions.create('padding-left', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen,
            }),
        }}
      >
        <MainNav />
        <Box
          component="main"
          sx={{
            flex: '1 1 auto',
            p: { xs: 2, sm: 3 },
            width: '100%',
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

const DashboardLayout = ({ children }) => (
  <SidebarProvider>
    <DashboardLayoutContent>{children}</DashboardLayoutContent>
  </SidebarProvider>
);

export default DashboardLayout;
